export default __webpack_public_path__ + "static/media/poster26.c9b709b8.png";